/*
 * @Copyright 2026. Institute for Future Intelligence, Inc.
 */

// Browser-local cache of the most recently accepted LEGAL_VERSION. Lets a
// returning user on the same browser skip the pre-auth gate without us
// having to authenticate first to read their Firestore doc. The Firestore
// record remains the authoritative source; this cache is a UX optimization
// shared by every sign-in surface (main toolbar, landing page, future
// entry points).

const ACCEPTED_VERSION_KEY = 'aims.acceptedTermsVersion';

export const readCachedAcceptance = (): string | null => {
  try {
    return localStorage.getItem(ACCEPTED_VERSION_KEY);
  } catch {
    return null;
  }
};

export const writeCachedAcceptance = (version: string) => {
  try {
    localStorage.setItem(ACCEPTED_VERSION_KEY, version);
  } catch {
    /* private mode / quota — fall back to re-prompting */
  }
};
